import React, { memo, useCallback } from 'react';
import { useAppDispatch } from "../../../store/hooks";
import { View } from "../../../store/types";
import { flipView } from "../../../store/reducer";
import { getTexts } from "../../../lib/contentful/defaultTexts";
import { CtaLink, ErrorBanner, ErrorMessage } from "../Message.styles";
import { NotificationTypes } from '@chegg-ui/notification-banner';
var NoCheggAccount = function NoCheggAccount() {
  var dispatch = useAppDispatch();
  var _getTexts = getTexts(),
    _getTexts$login = _getTexts.login,
    noCheggAccountText = _getTexts$login.noCheggAccountText,
    createAnAccountText = _getTexts$login.createAnAccountText;
  var flipToSignup = useCallback(function (e) {
    e.preventDefault();
    dispatch(flipView({
      view: View.SIGNUP
    }));
  }, [dispatch]);
  var renderCtaLink = function renderCtaLink() {
    return /*#__PURE__*/React.createElement(ErrorMessage, {
      "data-test": "no_chegg_account_error_link"
    }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("span", null, noCheggAccountText, " "), /*#__PURE__*/React.createElement(CtaLink, {
      "data-test": "no_chegg_account_flip_to_signup",
      onClick: flipToSignup
    }, createAnAccountText)));
  };
  return /*#__PURE__*/React.createElement(ErrorBanner, {
    "data-test": "no_chegg_account",
    title: '',
    type: NotificationTypes.Error,
    message: '',
    id: "no_chegg_account",
    bannerStyle: 'inline',
    ctaLink: renderCtaLink()
  });
};
export default /*#__PURE__*/memo(NoCheggAccount);